var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsqBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.693,
    height: 46.003,
    viewBox: "0 0 119.693 46.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#e1e833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2fd05a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b41212"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 119.693,
    height: 46.003,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#822973",
    floodOpacity: 0.435
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 12)",
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.69166564941406 14.50337600708008 L 8.001691818237305 14.50337600708008 C 4.416654586791992 14.50337600708008 1.500004649162292 11.58672618865967 1.500004649162292 8.001688957214355 C 1.500004649162292 4.416651248931885 4.416654586791992 1.500001430511475 8.001691818237305 1.500001430511475 L 81.69166564941406 1.500001430511475 C 85.27671813964844 1.500001430511475 88.19336700439453 4.416651248931885 88.19336700439453 8.001688957214355 C 88.19336700439453 11.58672618865967 85.27671813964844 14.50337600708008 81.69166564941406 14.50337600708008 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.001678466796875 3.000002861022949 C 5.243736267089844 3.000002861022949 2.999992370605469 5.243745803833008 2.999992370605469 8.001688957214355 C 2.999992370605469 10.7596321105957 5.243736267089844 13.00337409973145 8.001678466796875 13.00337409973145 L 81.69166564941406 13.00337409973145 C 84.44960784912109 13.00337409973145 86.69335174560547 10.7596321105957 86.69335174560547 8.001688957214355 C 86.69335174560547 5.243745803833008 84.44960784912109 3.000002861022949 81.69166564941406 3.000002861022949 L 8.001678466796875 3.000002861022949 M 8.001678466796875 3.814697265625e-06 L 81.69166564941406 3.814697265625e-06 C 86.11087799072266 3.814697265625e-06 89.69335174560547 3.582474708557129 89.69335174560547 8.001688957214355 C 89.69335174560547 12.42090320587158 86.11087799072266 16.00337409973145 81.69166564941406 16.00337409973145 L 8.001678466796875 16.00337409973145 C 3.582481384277344 16.00337409973145 -7.62939453125e-06 12.42090320587158 -7.62939453125e-06 8.001688957214355 C -7.62939453125e-06 3.582474708557129 3.582481384277344 3.814697265625e-06 8.001678466796875 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsqBar);
export default __webpack_public_path__ + "static/media/ISQ_bar.e6e95e2208f029f0426984100f4152d5.svg";
export { ForwardRef as ReactComponent };